export interface PaymentSchedule {
    paymentNumber: number;
    amount: number;
    dueDate?: string;
    autoDueDateType: DueDateType;
    autoDueDateDays: number;
    invitToPaySentDate?: string;
    invitToPaySentBy?: string;
    paymentCompleted: boolean;
    invoiceId?: string;
    comments: string;
}

export enum DueDateType {
    ManualDate = 0,
    AfterOrder = 1,
    BeforeInstallation = 2,
    AfterInstallation = 3,
}
